export default "__VITE_ASSET__c9b729ec__"